import { render, staticRenderFns } from "./matter_bom.vue?vue&type=template&id=5372454f&scoped=true&"
import script from "./matter_bom.vue?vue&type=script&lang=js&"
export * from "./matter_bom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372454f",
  null
  
)

export default component.exports